import { render, staticRenderFns } from "./DiscountRateDefermentDays.vue?vue&type=template&id=28aa4de7&"
import script from "./DiscountRateDefermentDays.vue?vue&type=script&lang=ts&"
export * from "./DiscountRateDefermentDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports